var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMediumPriority(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18991",
    "data-name": "Rectangle 18991",
    width: 30,
    height: 30,
    rx: 6,
    transform: "translate(55 388)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Medium_Priority",
    "data-name": "Medium Priority",
    transform: "translate(-55 -388)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_\\xCE\\xD3\\xC8_1",
    "data-name": "\\u2014\\xCE\\xD3\\xC8_1",
    transform: "translate(55.171 384.37)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10273",
    "data-name": "Group 10273",
    transform: "translate(0.829 29.169) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43664",
    "data-name": "Path 43664",
    d: "M1.8,28.34a1.8,1.8,0,0,1-1.431-2.9L9,14.171.372,2.9A1.8,1.8,0,1,1,3.235.709l9.472,12.365a1.8,1.8,0,0,1,0,2.192L3.235,27.632A1.794,1.794,0,0,1,1.8,28.34Z",
    fill: "#f7be00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43665",
    "data-name": "Path 43665",
    d: "M10.264,28.34a1.78,1.78,0,0,1-1.1-.374,1.8,1.8,0,0,1-.334-2.527l8.629-11.269L8.834,2.9A1.8,1.8,0,0,1,11.695.709l9.472,12.365a1.8,1.8,0,0,1,0,2.192L11.695,27.632a1.794,1.794,0,0,1-1.431.708Z",
    fill: "#f7be00"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediumPriority);
export default __webpack_public_path__ + "static/media/mediumPriority.0b1817f701ea090c449ebaaaa0b1e709.svg";
export { ForwardRef as ReactComponent };